export default __webpack_public_path__ + "static/media/icon - SOS Bell Disabled.a782fbfb.svg";